var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"gst-sign-up-link",attrs:{"href":_vm.url}},[_vm._v(" "+_vm._s(_vm.$t('_common:buttons.signUp'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }